export default __webpack_public_path__ + "static/media/pay.f20c2785.svg";